'use client';

import { Address } from 'viem';
import ClaimVault from './ClaimVault';
import { VAULT_LIST } from 'utils/staking';
import Typo from 'consts/typography';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import { StakingVaultResponse, UserStakingResponse } from 'models/stake';
import ClaimVaultOffChain from './ClaimVaultOffChain';
import { selectStakeList } from 'redux/userSlice';
import { useMemo } from 'react';

interface ClaimFormProps {
  isLoading: boolean;
  vaults?: StakingVaultResponse[];
}

const ClaimForm: React.FunctionComponent<ClaimFormProps> = ({ isLoading, vaults = null }) => {
  const t = useAppTranslation();
  const stakeList = useAppSelector(selectStakeList);

  const inactiveVaults = useMemo(() => {
    if (!vaults) return [];
    const vaultIds = new Set(vaults.map((vault) => vault.id));

    const uniqueStakingVaultDtos = new Map();

    stakeList.forEach((stake) => {
      const stakingVaultDtoId = stake.stakingVaultDto.id;
      if (!vaultIds.has(stakingVaultDtoId) && !uniqueStakingVaultDtos.has(stakingVaultDtoId)) {
        uniqueStakingVaultDtos.set(stakingVaultDtoId, stake.stakingVaultDto);
      }
    });

    return Array.from(uniqueStakingVaultDtos.values());
  }, [vaults, stakeList]);

  return (
    <div className="flex flex-col items-center gap-10 claim-form-wrap ">
      <h4 className={`${Typo.p2} primary-text-color text-center font-semibold`}>
        {t('staking.form.yourReward')}
      </h4>
      {isLoading ? (
        <span className="spiner-loader"></span>
      ) : (
        <div className="flex flex-col w-100 gap-20">
          {vaults ? (
            <>
              {inactiveVaults.map((vault) => (
                <ClaimVaultOffChain vault={vault} />
              ))}
              {vaults.map((vault) => (
                <ClaimVaultOffChain vault={vault} />
              ))}
            </>
          ) : (
            VAULT_LIST.map((vault) => (
              <ClaimVault
                key={vault.title}
                vaultAddress={vault.address as Address}
                vaultTitle={vault.title}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ClaimForm;
